export default [
	{
		path: "/admin/inventory/inventory-lists",
		name: "inventory-list",
		meta: { requiresAuth: true },
		component: () => import("@/pages/inventory/inventory-list/index.vue")
	}
];
